import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { formatMoney } from 'common/helpers'
import { DatePicker, Text, ArrowShortIcon } from 'common/components'
import { StatementDataType, TransactionDataType } from '../types'

const Wrapper = styled.div`
  /* position: relative; */
`
const Footer = styled.div<any>`
  /* position: absolute; */
  /* z-index: 9999; */
  /* bottom: 0; */
  /* left: 0; */
  /* right: 0; */
  /* transform: translateY(100%); */

  padding: 8px 16px;
  background-color: white;
  border: 1px solid #e6e7e9;
  border-top: none;
  border-radius: 0 0 4px 4px;

  cursor: pointer;

  & div {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 8px;
  }

  & div.arrow svg {
    transform: ${
      props => props.showDate ? 'rotate(270deg)' : 'rotate(90deg)'};
  }
`
const Body = styled.div<any>`
  display: grid;
  grid-template-columns: 1fr 108px 118px;
  gap: 1px;
  background-color: #ccced2;
  border: 1px solid ${props => !props.match ? '#e6e7e9':'#50dcaa'};
  border-radius: ${props => !props.match ? '4px':'4px 4px 0 0'};
  overflow: hidden;

  & div {
    width: 100%;
    background-color: ${props => !props.match ? 'white':'#a8eed5'};
    padding: 12px 16px;
  }
  & div.right {
    text-align: right;
  }
`

interface ISpecial {
  match?: boolean;
  onDateChange?: (date:any) => void
}
type PropsType = ISpecial & StatementDataType & TransactionDataType 

export const Slip: React.FC<Partial<PropsType>> = ({
  id,
  match,
  date,
  client, account,
  item, reference,
  description,notes,
  spent, received,
  onDateChange,
}) => {
  const [initId, setInitId] = useState<string>(null)
  const [newDate, setNewDate] = useState<string>('')

  const onFooterClick = () => {
    if (!newDate) setNewDate(date)
    else setNewDate('')
  }
  useEffect(() => {
    if (initId === id) return;
    // else
    setInitId(id)
    if (!!newDate) setNewDate('')
  }, [id, newDate])
  return (
    <Wrapper>
      <Body match={match}>
        <div>
          <Text size="xs">{date}</Text>
          <Text size="md" weight="medium">{client || account || ''}</Text>
          <Text size="md" weight="medium">{item || reference || ''}</Text>
          <Text size="md" weight="medium">{description || notes || 0}</Text> 
        </div>
        <div className='right'>
          <Text size="xs">Spent</Text>
          { !!spent && 
            <Text size="md" weight="medium">
              { formatMoney(spent, { 
                  prefix: false,
                  cents: true,
              })}
            </Text>
          }
        </div>
        <div className='right'>
          <Text size="xs">Received</Text>
          { !!received && 
            <Text size="md" weight="medium">
              { formatMoney(received, { 
                  prefix: false,
                  cents: true,
              }) }
            </Text>
          }
        </div>
      </Body>
      { !!match &&
        <Footer showDate={!!newDate}>
          <div className='arrow' onClick={onFooterClick}>
            <Text size="xs">Change Record Date</Text>
            <ArrowShortIcon />
          </div>
          { !!newDate && 
            <div style={{marginTop: '8px'}}>
              <DatePicker // format="DD/MM/y"
                onChange={onDateChange}
                disabledDate={(v:Date) => !v}
              />
            </div>
          }
        </Footer>
      }
    </Wrapper>
  )
}
